// Provider selection. Swapping a data provider is a change here only.
//
// Public, key-free tiles (terrain, base maps) are fetched by the browser directly. Anything that
// needs a key or benefits from caching goes through the Worker under `apiBase`.

export const config = {
  /** Base URL of the data-proxy Worker. Same-origin `/api` when deployed with Pages Functions. */
  apiBase: (import.meta.env.VITE_API_BASE as string | undefined) ?? '/api',

  terrain: {
    provider: 'terrarium' as const,
    // AWS Terrain Tiles (Mapzen Terrarium encoding), public S3 bucket. Upgrade path: Copernicus
    // GLO-30 self-tiled to R2 with the same encoding; only this URL changes.
    url: 'https://s3.amazonaws.com/elevation-tiles-prod/terrarium/{z}/{x}/{y}.png',
    maxzoom: 15,
    attribution:
      'Terrain: <a href="https://registry.opendata.aws/terrain-tiles/">AWS Terrain Tiles</a> (Mapzen, SRTM, GMTED, ETOPO1 and others)',
  },

  wind: { provider: 'open-meteo' as const },
  airspace: { provider: 'openaip' as const, tileZoom: 7 },
  geocoder: { provider: 'photon' as const },
  basemaps: { provider: 'default' as const },
};

export type TerrainConfig = typeof config.terrain;
